<script>
export default {
  name: 'ProductEmptyList',
};
</script>

<template>
  <div class="text-center">
    <i class="fas fa-search text-orange-500 text-2xl"></i>
    <h3 class="mt-2 text-lg font-medium text-gray-900">
      {{ $tc('products_title', 0) }}
    </h3>
  </div>
</template>
